import { createFileRoute, useNavigate } from '@tanstack/react-router';
import Icon from '@/components/ui/Icon.jsx';
import ResearchProfileView from '@/pages/ResearchProfileView.jsx';
import { getResearchProfile } from '@/api';

function PendingDossier() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
      <span className="spinner" />
    </div>
  );
}

function DossierError({ error }) {
  const navigate = useNavigate();
  return (
    <div className="empty-state">
      <Icon name="alert" size={36} stroke={1.5} />
      <h3>Couldn&rsquo;t load this profile</h3>
      <p>
        {error?.message || 'This research profile could not be found.'}
        {error?.status ? ` (HTTP ${error.status})` : ''}
      </p>
      <button type="button" className="btn btn-primary btn-md" onClick={() => navigate({ to: '/research-profiles' })}>
        <Icon name="chevronLeft" size={14} /> Back to research requests
      </button>
    </div>
  );
}

function ResearchProfileDetailRoute() {
  const profile = Route.useLoaderData();
  const navigate = useNavigate();
  return <ResearchProfileView profile={profile} onBack={() => navigate({ to: '/research-profiles' })} />;
}

export const Route = createFileRoute('/research-profiles/$id')({
  // Always fetches by id, however the user got here. GET /research-profiles
  // returns ResearchProfileSummary rows (no result/citations/raw_result), so
  // there is no partially-loaded row worth reusing — the dossier's data only
  // exists on GET /research-profiles/{id}.
  loader: ({ params }) => getResearchProfile(params.id),
  component: ResearchProfileDetailRoute,
  pendingComponent: PendingDossier,
  // Every open is now a real round-trip, so show the spinner promptly rather
  // than sitting on the list for the router's 1s default.
  pendingMs: 200,
  errorComponent: DossierError,
});
